import { render, staticRenderFns } from "./ArchivedConversationItem.vue?vue&type=template&id=3b39b96f"
import script from "./ArchivedConversationItem.vue?vue&type=script&lang=js"
export * from "./ArchivedConversationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports